import { Box, Chip, IconButton, Typography, Tooltip, } from "@mui/material";
import MaterialTable from "material-table";
import { useEffect, useState } from "react";
import { ConvertDate } from "../../../../Base/helper/baseFunctions";
import { useDispatch, useSelector } from "react-redux";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Popup from "../../../../Base/views/Popup";
import PermissionActionPopUp from "./PermissionActionPopUp";
import { GetApproverEmpPermissionMappingAction } from "../../../../../../store/Leave/MyAttendancePermission/Action";
import CommentIcon from '@mui/icons-material/Comment';
import BackdropMeepl from "../../../../Ancillary/AnimationComponents/BackdropMeepl";

const EmployeePermissionApproval = ({ value }) => {
  const dispatch = useDispatch();
  const { isLoading, approver_emp_permission_mapping } = useSelector(
    (state) => state?.LeaveReducer?.MyAttendancePermissionReducer,
  );
  const { atsModuleData } = useSelector((state) => state?.RoleAndAccessReducer?.ATSModuleReducer);
  const ExternalUserCoreHr = atsModuleData?.some((item) => item.module_name === "External User CoreHr");

  const [openPopup, setOpenPopup] = useState(false);
  const [editedRecord, setEditedRecord] = useState(null);

  const handleEdit = (rowData) => {
    setEditedRecord(rowData);
    setOpenPopup(true);
  };
  const closeMode = (resetForm) => {
    setEditedRecord(null);
    setOpenPopup(false);
  };

  const getFilteredData = () => {
    if (value === "2") {
      return approver_emp_permission_mapping?.filter((item) => item?.status === "Submitted");
    } else if (value === "3") {
      return approver_emp_permission_mapping?.filter((item) => item?.status === "Approved" || item?.status === "Rejected");
    } 
  };

  useEffect(() => {
    dispatch(GetApproverEmpPermissionMappingAction());
  }, [dispatch]);

  const tableTitle = (
    <Box>
      <Typography variant="h6" fontWeight={600}>
        {value === "3" ? "Processed Permission Requests" : "Permission Requests Requiring Action"}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {value === "3" ? "View requests you have approved or rejected" : "Approve or reject permission requests submitted by your reportees"}
      </Typography>
    </Box>
  );

  return (
    <Box>
      <Box
        sx={{
          borderRadius: "10px",
          maxHeight: "calc(100vh - 155px)",
          overflowY: "auto",
        }}
      >
        <MaterialTable
          columns={[
            { title: "Employee", field: "emp_name" },
            {
              title: "Date",
              field: "record_date",
              render: (data) => ConvertDate(data?.record_date),
            },
            {
              title: "Permission Hours", field: "daily_hours",
              headerStyle: {
                textAlign: "start",
                paddingLeft: "1%",
              },
              cellStyle: {
                textAlign: "start",
                padding: "0px 0px 0px 2%",
              },
            },
            {
              title: "Status",
              headerStyle: {
                textAlign: "start",
                paddingLeft: "2.2%",
              },
              cellStyle: {
                textAlign: "start",
                padding: "0px 0px 0px 0px",
              },
              field: "status",
              render: (rowData) => {
                const { bg, text } = getStatusColor(rowData?.status);
                return (
                  <Box sx={{ textAlign: "start", pl: "10px" }}>
                    <Chip
                      label={rowData.status}
                      style={{
                        backgroundColor: bg,
                        color: text,
                        fontWeight: 500,
                      }}
                      size="small"
                    />
                  </Box>
                );
              },
              hidden: value === "2",
            },
            {
              field: "comments",
              title: "Approver Comment",
              headerStyle: {
                textAlign: "start",
                padding: "5px",
              },
              cellStyle: {
                textAlign: "start",
                padding: "5px 0px 5px 30px",
              },
              sorting: false,
              hidden: value === "2",
              render: (rowData) => {
                return (
                  <Box width={"90%"}>
                    <Tooltip title={rowData?.comments || ""} arrow>
                      <CommentIcon sx={{
                        fontSize: "20px",
                        color: rowData?.comments ? "#637381" : "#95a0ab",
                        cursor: rowData?.comments ? "pointer" : "default",
                      }} />
                    </Tooltip>
                  </Box>
                );
              },
            },
          ]}
          data={getFilteredData()}
          isLoading={isLoading}
          options={{
            maxBodyHeight: "calc(100vh - 282px)",
            minBodyHeight: "calc(100vh - 282px)",
            rowStyle: {
              fontSize: "13px",
              height: "35px",
            },
            cellStyle: {
              padding: "5px 0px 5px 13px",
            },
            headerStyle: {
              padding: "5px 27px 5px 10px",
              fontWeight: "bold",
            },
            sorting: true,
            search: true,
            searchText: "",
            searchFieldAlignment: "right",
            searchAutoFocus: false,
            searchFieldVariant: "standard",
            filtering: false,
            paging: true,
            pageSizeOptions: [25, 50],
            pageSize: 25,
            paginationType: "stepped",
            showFirstLastPageButtons: false,
            paginationPosition: "bottom",
            exportButton: false,
            exportAllData: false,
            exportFileName: "Employees",
            addRowPosition: "first",
            selection: false,
            actionsColumnIndex: -1,
            grouping: false,
            columnsButton: false,
          }}
          actions={
            value === "2" ? [
              {
                icon: () => (
                  <IconButton sx={{ padding: "0px" }}>
                    <CheckCircleIcon color= {!ExternalUserCoreHr ? "primary" : "disabled"} />
                  </IconButton>
                ),
                disabled: ExternalUserCoreHr,
                tooltip: ExternalUserCoreHr ? "Action is disabled." : "Approve/Reject",
                onClick: (_event, rowData) => {
                  handleEdit(rowData);
                },
              },
            ] : []
          }
          components={{
            Overlay: () => null,
            OverlayLoading: () => <BackdropMeepl open={true} dark={false} />,
          }}
          title={tableTitle}
        />
        <Popup
          title={"Approve/Reject"}
          openPopup={openPopup}
          setOpenPopup={closeMode}
          fullWidth={true}
          maxWidth="xs"
        >
          <PermissionActionPopUp
            editedRecord={editedRecord}
            closeMode={closeMode}
          />
        </Popup>
      </Box>
    </Box>
  );
};

export default EmployeePermissionApproval;

const getStatusColor = (status) => {
  switch (status) {
    case "Pending Approval":
    case "Action Needed":
      return { bg: "#FFF4E5", text: "#FFA726" }; // yellow
    case "Approved":
    case "Self Approved":
      return { bg: "#E8F5E9", text: "#66BB6A" }; // green
    case "Rejected":
      return { bg: "#FFEBEE", text: "#EF5350" }; // red
    case "Submitted":
      return { bg: "#E3F2FD", text: "#42A5F5" }; // blue
    default:
      return { bg: "#E5E7EB", text: "#374151" }; // gray
  }
};
